/**
 * @file
 * Kit view: a container with header/footer and the core loader.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { el } = berTags.dom;
  const { Container, events } = window.BerUi;
  const { LOADING, LOADED } = events;
  const ui = Drupal.berUI;
  const { container } = ui.compose;

  // A container with an optional header and footer around its body, and the
  // core loader watching every descendant component.
  ui.view = ({
    classes = '',
    header = false,
    footer = false,
    loader = true,
  } = {}) => {
    const root = el('div', `ber-ui__view ${classes}`.trim());
    const head = header ? el('div', 'ber-ui__view-header') : null;
    const body = el('div', 'ber-ui__view-body');
    const foot = footer ? el('div', 'ber-ui__view-footer') : null;
    if (head) {
      root.appendChild(head);
    }
    root.appendChild(body);
    if (foot) {
      root.appendChild(foot);
    }
    const api = container(
      Object.assign(new Container(root), {
        header: head,
        body,
        footer: foot,
        show() {
          root.hidden = false;
          return api;
        },
        hide() {
          root.hidden = true;
          return api;
        },
      }),
      { header: head, body, footer: foot },
    );
    if (loader) {
      api.spinner = components.spinner();
      root.appendChild(api.spinner.el);
      let pending = 0;
      root.addEventListener(LOADING, () => {
        pending++;
        api.spinner.show(150);
      });
      root.addEventListener(LOADED, () => {
        pending = Math.max(0, pending - 1);
        if (!pending) {
          api.spinner.hide();
        }
      });
    }
    ui.emit('view', { component: api });
    return api;
  };

  ui.register('view', ui.view);
})(Drupal);
